<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscription - user's watch time</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item">Reports</li>
              <li class="breadcrumb-item active">Subscription - user's watch time</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <button
                class="btn btn-info"
                @click="showFilter = !showFilter"
              ><i class="fa fa-filter"></i>Filter
              </button>
            </div>
            <div class="card-tools">
              <button class="btn btn-info" @click="exportFile()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="showFilter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="name">Name</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="name"
                        class="form-control"
                        v-model="filter.name"
                        placeholder="name"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username">Username</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="username"
                        class="form-control"
                        v-model="filter.username"
                        placeholder="username"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="course_title">Course title</label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        id="course_title"
                        class="form-control"
                        v-model="filter.course_title"
                        placeholder="course_title"
                      />
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="watched_date">Watched date range</label>
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.watched_date"
                        range
                        lang="en"
                        format="YYYY-MM-DD"
                        confirm
                        id="watched_date"
                        value-type="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
              <tr>
                <th>SL#</th>
                <th>Name</th>
                <th>Username</th>
                <th>Course</th>
                <th>Total watch time (minutes)</th>
                <th>Date</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(record, index) in records.data">
                <td>{{ index + 1}}</td>
                <td>{{ record.user.name }}</td>
                <td>{{ record.user.username }}</td>
                <td>{{ record.course.course_title }}</td>
                <td>{{ record.total_watch_duration }}</td>
                <td>{{ record.watched_date | custom_date }}</td>
              </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(records.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="records"
              v-if="records.total > records.per_page"
              @paginate="getRecords()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent"
import {LearningReportApi} from "@/services/api"

import DatePicker from "vue2-datepicker"
import "vue2-datepicker/index.css"
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "SubscriptionUsersWatchDuration",
  metaInfo: {
    title: "Subscription users watch duration | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
  },
  data: () => ({
    records: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    filter: {},
    showFilter: false,
    is_loading: false,
  }),
  methods: {
    getRecords() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query))
      if (!_.isEmpty(this.filter)) this.showFilter = true
      this.is_loading = true
      let params = {...this.filter, ...this.$route.query}
      LearningReportApi.subscriptionsUserWatchDuration(params)
        .then((response) => {
          this.records = response
        })
        .finally(() => {
          this.is_loading = false
        });
    },

    resetFilter() {
      this.$router.push({path: this.$route.path}).catch(() => {})
    },

    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err)
        });
    },

    exportFile: function () {
      this.is_loading = true;
      axios
        .get("/reports/subscriptions/user-watch-duration-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "SubscriptionsUserWatchDuration.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  mounted() {
    this.getRecords()
  },
  filters: {
    custom_date: function (date) {
      return moment(date).format("D MMMM, YYYY")
    },
  },
};
</script>
